exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wrapper[data-v-2197ae22] {\n    width: 100%;\n    display: flex;\n    color:black;\n    font-size: 16px;\n    letter-spacing: .05em;\n    gap: 44px;\n}\n.image[data-v-2197ae22] {\n    flex: 1;\n    width: 100%;\n    height: auto;\n    object-fit: contain;\n    display: block;\n}\n.blockA[data-v-2197ae22] {\n    flex: 1;\n    margin: 0px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2197ae22","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/HomeDefault.vue
// module id = 457
// module chunks = 0